export default __webpack_public_path__ + "static/media/img-user.41a8c066.png";